import thunk from "redux-thunk";
// import { thunk } from "redux-thunk";
import { numBikeReducer } from "../Reducer/NumBikereducer";
import { numCarReducer } from "../Reducer/NumCarreducer";
// import { numCommercialReducer } from "../Reducer/NumCommercialreducer";
import CommercialReducer from "../actions/CommercialSlice";
import { numLifeReducer } from "../Reducer/NumLifereducer";
import { numHealthReducer } from "../Reducer/NumHealthreducer";
import { numTravelReducer } from "../Reducer/NumTravelreducer";
import { PospReducer } from "../Reducer/PospReducer";
import { PassReducer } from "../Reducer/PospReducer";
import { UatReducer } from "../Reducer/NumBikereducer";
import { QQcommon } from "../Reducer/NumBikereducer";
import countdownReducer from "../Reducer/TrainingTimeReducer";
import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
// import { composeWithDevTools } from "redux-devtools-extension";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { reducer } from "../reducer";
import hardSet from "redux-persist/es/stateReconciler/hardSet";
// import autoMergeLevel1 from "redux-persist/es/stateReconciler/autoMergeLevel1";

const rootReducer = combineReducers({
  vehicledetail: numBikeReducer,
  cardetail: numCarReducer,
  healthdetail: numHealthReducer,
  traveldetail: numTravelReducer,
  commercialdetail: CommercialReducer,
  lifedetail: numLifeReducer,
  addressdetail: reducer,
  common: QQcommon,
  posp: PospReducer,
  pass: PassReducer,
  test: UatReducer,
  timer: countdownReducer,
});

const persistConfig = {
  key: "vibe_prd_root",
  storage: storage,
  stateReconciler: hardSet,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Middleware callback function
// const middleware = (getDefaultMiddleware) =>
//   getDefaultMiddleware().concat(thunk);

// const middleware = (getDefaultMiddleware) =>
//   getDefaultMiddleware({
//     serializableCheck: {
//       ignoredActions: ["persist/PERSIST"],
//       ignoredPaths: ["register"],
//     },
//   }).concat(thunk);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

  // devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);
